// extracted by mini-css-extract-plugin
export var container = "PrivateHero-module--container--1mFKZ";
export var image = "PrivateHero-module--image--3ZnkZ";
export var content = "PrivateHero-module--content--3wfcR";
export var enquiryNav = "PrivateHero-module--enquiryNav--1DHzG";
export var navText = "PrivateHero-module--navText--2apDl";